import React from 'react';

import { HawkWidgetContext } from './HawkWidgetContext';
import type { HawkWidgetContextType } from './model';

interface HawkWidgetContextProviderProps {
  children: React.ReactNode;
}

const HawkWidgetContextProvider: React.FC<HawkWidgetContextProviderProps> = (props) => {
  const { children } = props;

  return (
    // TODO(Petr): HAWK-7003 VERY unsafe cast!
    //  Works only because props in HawkWidgetContextType and WidgetProps (partially) overlap
    //  and because HawkWidgetContextProvider is always provided with "more" props than it actually
    //  says it needs.
    <HawkWidgetContext.Provider value={props as HawkWidgetContextType}>
      {children}
    </HawkWidgetContext.Provider>
  );
};

export default HawkWidgetContextProvider;
